module.exports = __webpack_public_path__ + "img/upload.d35c4880.svg";